/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const TokenPaymentMethod = {
    XP: 'XP',
    FIAT: 'FIAT'
} as const;
export type TokenPaymentMethod = typeof TokenPaymentMethod[keyof typeof TokenPaymentMethod];


export function instanceOfTokenPaymentMethod(value: any): boolean {
    for (const key in TokenPaymentMethod) {
        if (Object.prototype.hasOwnProperty.call(TokenPaymentMethod, key)) {
            if (TokenPaymentMethod[key as keyof typeof TokenPaymentMethod] === value) {
                return true;
            }
        }
    }
    return false;
}

export function TokenPaymentMethodFromJSON(json: any): TokenPaymentMethod {
    return TokenPaymentMethodFromJSONTyped(json, false);
}

export function TokenPaymentMethodFromJSONTyped(json: any, ignoreDiscriminator: boolean): TokenPaymentMethod {
    return json as TokenPaymentMethod;
}

export function TokenPaymentMethodToJSON(value?: TokenPaymentMethod | null): any {
    return value as any;
}

export function TokenPaymentMethodToJSONTyped(value: any, ignoreDiscriminator: boolean): TokenPaymentMethod {
    return value as TokenPaymentMethod;
}

